import React, {Component, PropTypes} from 'react'
import Cannonicalize from './Cannonicalize'
import Analytics from './Analytics'
/*
  'abstract' aparently includes html, and we are hoping that means only p tags.
*/
class Tile extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    this.state = Cannonicalize.story(props.story);
    this.width = props.width || 320;
    this.height = props.height || 180;
    this.gradient = props.gradient || false;
    this.orientation = props.orientation === 'landscape'
      ? 'landscape'
      : 'portrait';
    this.imageLeft = props.imageLeft;
    this.imageNotFound = "https://ftpcontent.worldnow.com/griffin/NEXGEN_Images/imageNotFound16x9.png"
  }
  componentWillReceiveProps(nextProps) {
    this.setState(Cannonicalize.story(nextProps.story))
  }

  render() { // REQUIRED
    let imagePath = this.state.abstractimage.filename || this.state.abridged.abstractimage.filename
    if(!imagePath){
      let error = new Error('*Producer* abstract image missing from Story #'+ this.state.id )
      Analytics.reportError(error)
      imagePath = this.imageNotFound
    }
    imagePath +=  '?width=' + this.width
    imagePath += '&height=' + this.height

    return (<div className={'gnm-tile ' + this.orientation}>
      <a href={this.state.link.replace('http://www.newson6.com', '').replace('http://www.news9.com', '').replace('//www.newson6.com', '').replace('//www.news9.com', '')} className={(
          this.gradient )
          ? 'gradient'
          : ''}>
      <img className={'lazyloaded img-responsive ' + (
                  this.imageLeft
                  ? 'image-left'
                  : '')}
            src={imagePath}
            aria-label={this.state.headline}
            onError={(e) => {
                  let error = new Error('*Back-end* abstract image path ' + imagePath + ' failing to load')
                  Analytics.reportError(error)
                  e.target.src = this.imageNotFound
                }}/>

        <h3 className={this.state.surfaceable
            ? 'play-button h6'
            : 'h6'}>{this.state.headline}</h3>
        <span className='byline' onClick={(e)=>{e.stopPropagation();e.preventDefault()}}>{this.state.bylines[0].firstname + ' ' + this.state.bylines[0].lastname}</span>
        <span onClick={(e)=>{e.stopPropagation();e.preventDefault()}} className='hidden-xs abstract' dangerouslySetInnerHTML={{__html:this.state.abstract}}></span>
      </a>
    </div>)
  }
}


export default Tile



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Tile.js